import { FIELD_PATH_BUSINESS_NAME, FIELD_PATH_HOURS, FIELD_PATH_PRIMARY_EMAIL, FIELD_PATH_PRIMARY_PHONE, FIELD_PATH_SERVICE_AREA_NAME, FIELD_PATH_SERVICE_NAME, } from "../contracts/business-graph-contradiction.js";
/**
 * Extract field-aware comparable facts from one BusinessGraph snapshot.
 * Does not invent multi-source phones — a single graph yields at most one primaryPhone fact.
 * Multi-source phone conflicts require additional facts (other candidates / overlays).
 */
export function extractComparableFactsFromBusinessGraph(graph, options) {
    const facts = [];
    const base = {
        agencyId: graph.agencyId,
        projectId: graph.projectId,
        state: options.state,
        sourceRef: options.sourceRef,
        revisionId: graph.revisionId,
        candidateId: options.candidateId,
    };
    facts.push({
        factId: `${graph.revisionId}:business.businessName`,
        fieldPath: FIELD_PATH_BUSINESS_NAME,
        value: graph.business.businessName,
        scopeKey: "",
        ...base,
    });
    if (graph.business.primaryPhone?.trim()) {
        facts.push({
            factId: `${graph.revisionId}:business.primaryPhone`,
            fieldPath: FIELD_PATH_PRIMARY_PHONE,
            value: graph.business.primaryPhone,
            scopeKey: "",
            ...base,
        });
    }
    if (graph.business.primaryEmail?.trim()) {
        facts.push({
            factId: `${graph.revisionId}:business.primaryEmail`,
            fieldPath: FIELD_PATH_PRIMARY_EMAIL,
            value: graph.business.primaryEmail,
            scopeKey: "",
            ...base,
        });
    }
    graph.operations.hours.forEach((row, index) => {
        const close = row.close ?? "";
        facts.push({
            factId: `${graph.revisionId}:operations.hours[${index}]`,
            fieldPath: FIELD_PATH_HOURS,
            value: `${row.open}|${close}`,
            scopeKey: `day:${row.dayOfWeek}`,
            ...base,
        });
    });
    for (const service of graph.services) {
        facts.push({
            factId: `${graph.revisionId}:services[${service.id}].name`,
            fieldPath: FIELD_PATH_SERVICE_NAME,
            value: service.name,
            scopeKey: `id:${service.id}`,
            ...base,
        });
    }
    graph.operations.serviceAreas.forEach((area, index) => {
        const scope = area.id?.trim() ? `id:${area.id}` : `idx:${index}`;
        facts.push({
            factId: `${graph.revisionId}:operations.serviceAreas[${scope}].name`,
            fieldPath: FIELD_PATH_SERVICE_AREA_NAME,
            value: area.name,
            scopeKey: scope,
            ...base,
        });
    });
    return facts;
}
//# sourceMappingURL=extract-comparable-facts-from-business-graph.js.map